import { openaiUsage } from "../openai/usage";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cerebras = defineConnector({
  identifier: "cerebras",
  name: "Cerebras",
  tagLine: "AI inference on wafer-scale hardware",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.cerebras\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Cerebras Cloud](https://cloud.cerebras.ai/) and create an API key from the API keys page.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          placeholder: "csk-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cerebras.ai/v1/models",
  },
  usage: openaiUsage(),
});
